import React from 'react';
import cn from 'classnames';

import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';

import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRightOutlined';
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  listItemText: {
    fontFamily: 'Raleway',
    fontSize: '18px',
    color: '#6a27e8',
    textAlign: 'center',
  },
  nestedSecondary: {
    paddingLeft: '40px',
  },
});

const PrimaryEntries = ({ classes, items, onShowSubmenu, onNavigate }) => {
  return (
    <>
      {map(items, (item, index) => {
        const hasSubmenu = !isEmpty(item.submenu);

        return hasSubmenu ? (
          <ListItem key={`list-item-${index}`}>
            <ListItemText
              classes={{
                primary: cn(classes.listItemText, classes.nestedSecondary),
              }}
              primary={item.name}
              onClick={() => onShowSubmenu(item)}
            />
            <KeyboardArrowRightIcon />
          </ListItem>
        ) : (
          <ListItem key={`list-item-${index}`}>
            <ListItemText
              classes={{ primary: classes.listItemText }}
              primary={item.name}
              onClick={() => onNavigate(item.url)}
            />
          </ListItem>
        );
      })}
    </>
  );
};

export default withStyles(styles)(PrimaryEntries);
